import React from "react";
import { labels } from "../../../localization/labels";

const NotFound = () => <div>{labels.pageNotFound}</div>;

export default NotFound;
